import React, {Component} from "react";
import ParticlesJS from "react-particles-js";
import "./Particles.css";

import options from "./config/main";

export default class Particles extends Component
{
	render()
	{
		return (
			<ParticlesJS
				width="100%"
				height="100%"
				params={options}
				className="particles"
			/>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/Hero/Particles/Particles.js